/**
 * A branch id to ask WORKSPACE-level questions with — governance and disclosure (ADR-0024).
 *
 * The consolidated board deliberately carries no `branchId`: its scope is the SET of every branch, and a
 * single id there would be a lie about what the numbers cover. But the finance-setup query is keyed on a
 * branch, so passing `null` disabled it outright — and the Global board lost the two org-wide facts it needs.
 *
 * The visible cost was the whole point of the governance mode disappearing: no banner naming the mode, and,
 * once the server began withholding, every money widget still on the board rendering `$0.00`. A branch
 * holding $1,200 and a branch holding nothing looked identical.
 *
 * Governance and disclosure are org-wide, so ANY branch of the workspace answers them. This is a branch that
 * EXISTS, never a claim about what the board covers — which is why it is a separate value from `branchId`
 * rather than a fallback smuggled into it.
 */
export const resolveIdentityBranchId = (
  /** The board's real scope. Null on the consolidated board, by design. */
  branchId: string | null,
  candidates: { parishBranchId?: string | null; scopeBranchId?: string | null },
): string | null => branchId ?? candidates.parishBranchId ?? candidates.scopeBranchId ?? null
